/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
// Component
import SectionUI from '@components/UI/Common/SectionUI';
import Quote from '@landing_pages/project-samskriti/Quote';

/* Services */
/* Styles */

/**
 * Renders Expression Component
 * @param {Object} sectionContent - data for the section from api
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 */
const Description = ({ sectionContent, lang, region }) => {
  return (
    <Box w="full">
      {sectionContent && sectionContent.length
        ? sectionContent.map(section => {
          if (section._modelApiKey === 'quote') {
            return (
              <Quote
                key={nanoid(5)}
                sectionContent={section}
                lang={lang}
                region={region}
              />
            );
          } else {
            return (
              <SectionUI
                key={nanoid(4)}
                sectionContent={section}
                region={region}
                language={lang}
              />
            );
          }
        })
        : null}
    </Box>
  );
};

export default Description;
